import React from "react";
import { Box, Typography } from "@mui/material";

export function CertificationsTab() {
    return <Box sx={{ p: '5px', pb: '25px' }}>
            <Typography variant="h6" gutterBottom sx={{ mb: 3 }}>Certifications/Background Checks</Typography>
            <form id="tab">
                <p>Optional. This will set this provider apart from the rest. <br/><br/>License <br/><br/>Background
                    Checks</p>
                <button type="submit" className="save-button" value="Submit">Save</button>
            </form>
    </Box>;
}

